import { apiAxios } from '@/lib/apiAxios';
export const fetchContexts = async () => apiAxios.get('/contexts').then((response) => response.data);
